contactHandler = {
    $contactSection = $('.contact-section'),
    $contentTitle = $contactSection.find('.content-title'),
    $gridContact = $contactSection.find('.grid-contact'),
    $window = $(window),
    isOnLoad = false,
    lastWindowWidth = $window.width(),
    resizeTimeout = null,
    
    init = function(){
        var self = this;
        this.isOnLoad = true;

        // animateHandler.animateScroll( this.$contentTitle ); 
        // animateHandler.animateParallax( this.$gridContact );

        this.$window.resize(function(){
            clearTimeout(self.resizeTimeout);
            self.resizeTimeout = setTimeout(function() {
                if (self.isOnLoad) {
                    self.isOnLoad = false;   
                } else {
                    var windowWidth = $window.width();
                    if (windowWidth != self.lastWindowWidth) {
                        // animateHandler.animateScroll( $contentTitle , 1, true ); 
                        self.lastWindowWidth = windowWidth;
                    }
                }       
            }, 25);
        });
    }
}